<template>
  <!-- 首页 -->
  <section id="home" class="page-section bg-white pt-32 pb-20 relative bg-gradient-to-b from-white to-light-gray">
    <div class="container mx-auto px-6 md:px-12 relative z-10 flex-grow">
      <div class="about-container">
        <div class="flex flex-col items-center">
          <!-- 文字内容区域 -->
          <div class="w-full max-w-3xl text-center">
            <!-- 核心标语：逐字浮现+渐变流动+粒子环绕 -->
            <div class="particle-container mb-8">
              <h1 id="core-slogan" class="text-[clamp(2.8rem,10vw,5.5rem)] font-bold leading-tight text-glow" />
            </div>
            <p class="text-md md:text-2xl mb-10 text-reveal" :style="{ 'animation-delay': this.$i18n.locale === 'en' ? '6s' : '2.5s' }">
              {{ $t('about-content') }}
            </p>
            <div class="flex flex-col sm:flex-row justify-center gap-4 mb-12 text-reveal" :style="{ 'animation-delay': this.$i18n.locale === 'en' ? '6.5s' : '3s' }">
              <a
                href="#games"
                class="bg-gradient-to-r from-primary to-secondary text-white px-8 py-4 rounded-full font-medium text-center md:text-lg transition-all hover:opacity-90"
              >
                {{ $t('about-games') }}
              </a>
              <a
                v-if="newsShow"
                href="#news"
                class="gradient-border text-dark-text px-8 py-4 rounded-full font-medium text-center transition-all hover:bg-light-gray md:text-lg"
              >
                {{ $t('about-updates') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a href="/index#games">
      <!-- pc端下滑提示 - 鼠标样式 -->
      <div id="pc_mouse" class="absolute bottom-10 transform -translate-x-1/2 text-reveal" :style="{'left': '49.5%', 'animation-delay': this.$i18n.locale === 'en' ? '7s' : '3.5s' }">
        <div class="scroll-mouse">
          <span class="scroll-tooltip">Scroll down to explore more</span>
        </div>
      </div>

      <!-- 移动端向下滚动指示 -->
      <div class="md:hidden absolute bottom-10 text-center transform -translate-x-1/2 text-reveal" :style="{'left': '46%', 'animation-delay': this.$i18n.locale === 'en' ? '7s' : '3.5s' }">
        <div class="scroll-arrows">
          <div class="scroll-arrow" />
          <div class="scroll-arrow" />
          <div class="scroll-arrow" />
        </div>
      </div>
    </a>
  </section>
</template>

<script>
import store from '@/store'
import { get_news_introduction_page } from '@/api/news'

export default {
  name: 'About',
  data() {
    return {
      newsShow: true
    }
  },
  watch: {
    // 监听语言变化
    '$i18n.locale'() {
      this.updateContent()
      this.checkNewsDiv()
    }
  },
  async mounted() {
    // 核心标语逐字动画实现
    const sloganElement = document.getElementById('core-slogan')
    const container = sloganElement.parentElement

    // 创建粒子效果
    createParticles(container, 36)

    // 创建粒子效果
    function createParticles(container, count) {
      for (let i = 0; i < count; i++) {
        const particle = document.createElement('div')
        particle.classList.add('particle')

        // 随机大小和位置
        const size = Math.random() * 15 + 5
        particle.style.width = `${size}px`
        particle.style.height = `${size}px`
        particle.style.left = `${Math.random() * 100}%`
        particle.style.top = `${Math.random() * 100}%`
        particle.style.animationDelay = `${Math.random() * 5}s`
        particle.style.animationDuration = `${Math.random() * 6 + 6}s`

        container.appendChild(particle)
      }
    }

    // 滚动动画增强
    const animateOnScroll = () => {
      const elements = document.querySelectorAll('.text-reveal:not([data-animated="true"])')
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top
        const elementVisible = 150

        if (elementTop < window.innerHeight - elementVisible) {
          element.setAttribute('data-animated', 'true')
          // 添加额外的强调效果
          setTimeout(() => {
            element.classList.add('animate-pulse-slow')
            setTimeout(() => {
              element.classList.remove('animate-pulse-slow')
            }, 1000)
          }, 500)
        }
      })
    }

    window.addEventListener('scroll', animateOnScroll)

    // 初始加载时检查
    await this.checkNewsDiv()
    await this.updateContent()
    animateOnScroll()
  },
  methods: {
    // 動態更新標語
    async updateContent() {
      const currentSearch = window.location.search
      const urlParams = new URLSearchParams(currentSearch)
      const { langList } = store.state
      this.$i18n.locale = langList.includes(urlParams.get('lang')) ? urlParams.get('lang') : 'en'
      const sloganText = this.$i18n.t('about-title')
      const sloganElement = document.getElementById('core-slogan')

      // 清空容器并添加文字
      sloganElement.innerHTML = ''

      // 按空格拆分单词（保留原始空格逻辑）
      const words = sloganText.split(' ')
      let totalCharIndex = 0 // 记录全局字符索引（用于动画延迟和特殊样式）

      words.forEach((word, wordIdx) => {
        // 1. 创建单词容器（关键：锁住整个单词）
        const wordWrap = document.createElement('span')
        // 保证单词不断开
        const style = this.$i18n.locale === 'en' ? 'nowrap' : 'normal'
        wordWrap.style = 'white-space: ' + style

        // 2. 遍历单词内的每个字符
        for (const element of word) {
          const charSpan = document.createElement('span')
          charSpan.className = 'char-item'
          charSpan.textContent = element // 直接用原字符，不替换空格（因为这里是单词内字符）

          // 动画延迟：全局递增（确保逐字效果连贯）
          charSpan.style.animationDelay = `${0.15 * totalCharIndex}s`

          // 特殊样式（按全局索引判断）
          if ((totalCharIndex >= 4 && totalCharIndex <= 16) ||
            (totalCharIndex >= sloganText.length - 12 && totalCharIndex <= sloganText.length - 1)) {
            charSpan.classList.add('text-gradient', 'from-primary', 'to-secondary', 'bg-gradient-to-r')
          }

          wordWrap.appendChild(charSpan)
          totalCharIndex++
        }

        // 3. 添加单词容器到主容器
        sloganElement.appendChild(wordWrap)

        // 4. 单词之间加空格（最后一个单词不加）
        if (wordIdx !== words.length - 1) {
          const space = document.createTextNode(' ') // 用文本节点添加空格（更原生）
          sloganElement.appendChild(space)
        }
      })
    },
    async checkNewsDiv() {
      const selectPage = {
        langType: this.$i18n.locale || 'en',
        pageNum: 1,
        pageSize: 3
      }
      await get_news_introduction_page(selectPage).then(data => {
        this.newsShow = data.d.length > 0
      })
    }
  }
}
</script>

<style scoped>
/* 内容容器上下左右居中 */
.about-container {
  /* 设置为flex布局 */
  display: flex;
  /* 水平方向居中 */
  justify-content: center;
  /* 垂直方向居中 */
  align-items: center;
  /* 让容器占满整个视口高度（确保垂直居中生效） */
  height: 80vh;

  @media (max-width: 800px) {
    margin-bottom: -2.8rem;
  }
}

/* 放大h1文字 */
.about-container h1 {
  @media (max-width: 800px) {
    font-size: 2.5rem;
  }
  @media (min-width: 800px) {
    font-size: 5.5rem;
  }
  font-weight: bold;
}

#pc_mouse {
  @media (max-width: 800px) {
    display: none;
  }
  @media (min-width: 800px) {
    visibility: visible;
  }
}
</style>
